import { DocumentFusionFieldsDTO } from 'src/app/shared/models/iCourrier/document-template';

export interface MergeFieldsForEditor {
  [key: string]: {
    description: string;
    fields: { key: string; description: string }[];
  };
}

/**
 * Converts the flat fusion fields returned by the API (one array per category) into the
 * grouped shape expected by i-richedit's `[mergeFields]` input, where each category needs
 * a `description` and a `fields` array.
 */
export function toMergeFieldsForEditor(dto: DocumentFusionFieldsDTO): MergeFieldsForEditor {
  const result: MergeFieldsForEditor = {};
  Object.entries(dto ?? {}).forEach(([key, fields]) => {
    result[key] = { description: key, fields: Array.isArray(fields) ? fields : [] };
  });
  return result;
}
